
import { parseWorkflowProject } from './utils/pssHelper';
import { WorkflowProject } from './types';

const projectData: WorkflowProject = {
  "Name": "Peak_Workflow_Project",
  "Version": 1,
  "Resources": {
    "1": {
      "Kind": 5,
      "Source": "// Generate company email\nconst name = variables.fullName || 'User';\nconst dept = variables.dept || 'Corp';\nconst email = name.toLowerCase().replace(' ', '.') + '@peak-systems.com';\n\nreturn {\n  generatedEmail: email,\n  onboardingId: 'ONB-' + Math.floor(Math.random() * 10000)\n};"
    },
    "2": {
      "Kind": 5,
      "Source": "// Extract severity from alert payload\nconst severity = variables.alert?.severity || 'LOW';\n\nreturn {\n  isCritical: severity === 'CRITICAL',\n  requiresManager: severity === 'HIGH' || severity === 'CRITICAL'\n};"
    }
  },
  "Processes": [
    {
      "Name": "Employee Onboarding",
      "IsSubProcess": false,
      "Nodes": [
        {
          "type": "BlankStartEvent",
          "Id": 1,
          "X": 50,
          "Y": 200,
          "Text": "New Hire Trigger",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"FormStartEvent\",\"data\":{\"label\":\"New Hire Trigger\",\"status\":\"idle\",\"formTitle\":\"New Hire Details\",\"formSchema\":{\"fields\":[{\"id\":\"f1\",\"label\":\"Full Name\",\"key\":\"fullName\",\"type\":\"text\",\"required\":true},{\"id\":\"f2\",\"label\":\"Department\",\"key\":\"dept\",\"type\":\"select\",\"options\":\"Engineering,Sales,HR\",\"required\":true},{\"id\":\"f3\",\"label\":\"Start Date\",\"key\":\"startDate\",\"type\":\"date\",\"required\":true}]}},\"position\":{\"x\":50,\"y\":200}}"
            },
            {
              "Name": "PSS.Forms",
              "Data": {
                "FormFields": [
                  {
                    "Id": "fullName",
                    "Label": "Full Name",
                    "Required": true,
                    "ValueType": "string",
                    "Extensions": {
                      "input": "text"
                    }
                  },
                  {
                    "Id": "dept",
                    "Label": "Department",
                    "Required": true,
                    "ValueType": "enum",
                    "Extensions": {
                      "input": "select",
                      "options": "Engineering,Sales,HR"
                    }
                  },
                  {
                    "Id": "startDate",
                    "Label": "Start Date",
                    "Required": true,
                    "ValueType": "date",
                    "Extensions": {
                      "input": "datepicker"
                    }
                  }
                ]
              }
            }
          ]
        },
        {
          "type": "ScriptTask",
          "Id": 2,
          "X": 250,
          "Y": 200,
          "Text": "Generate Email",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ScriptTask\",\"data\":{\"label\":\"Generate Email\",\"status\":\"idle\",\"scriptLanguage\":\"javascript\",\"script\":\"// Generate company email\\nconst name = variables.fullName || 'User';\\nconst dept = variables.dept || 'Corp';\\nconst email = name.toLowerCase().replace(' ', '.') + '@peak-systems.com';\\n\\nreturn {\\n  generatedEmail: email,\\n  onboardingId: 'ONB-' + Math.floor(Math.random() * 10000)\\n};\"},\"position\":{\"x\":250,\"y\":200}}"
            }
          ],
          "Script": 1
        },
        {
          "type": "ParallelGateway",
          "Id": 3,
          "X": 450,
          "Y": 200,
          "Text": "Split Streams",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ParallelGateway\",\"data\":{\"label\":\"Split Streams\",\"status\":\"idle\",\"isMerging\":false},\"position\":{\"x\":450,\"y\":200}}"
            }
          ],
          "IsMerging": false
        },
        {
          "type": "UserTask",
          "Id": 4,
          "X": 600,
          "Y": 100,
          "Text": "IT Provisioning",
          "comment": "Setup laptop and accounts",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"UserTask\",\"data\":{\"label\":\"IT Provisioning\",\"status\":\"idle\",\"description\":\"Setup laptop and accounts\",\"assignee\":\"it-support\",\"priority\":\"2\",\"formSchema\":{\"fields\":[{\"id\":\"it1\",\"label\":\"Laptop Serial\",\"key\":\"laptopId\",\"type\":\"text\",\"required\":true},{\"id\":\"it2\",\"label\":\"Access Card ID\",\"key\":\"cardId\",\"type\":\"text\",\"required\":true}]}},\"position\":{\"x\":600,\"y\":100}}"
            },
            {
              "Name": "PSS.Forms",
              "Data": {
                "FormFields": [
                  {
                    "Id": "laptopId",
                    "Label": "Laptop Serial",
                    "Required": true,
                    "ValueType": "string",
                    "Extensions": {
                      "input": "text"
                    }
                  },
                  {
                    "Id": "cardId",
                    "Label": "Access Card ID",
                    "Required": true,
                    "ValueType": "string",
                    "Extensions": {
                      "input": "text"
                    }
                  }
                ]
              }
            },
            {
              "Name": "PSS.GenericUserTask",
              "Data": {
                "Assignments": [],
                "Mode": "continue",
                "Step": 1,
                "Rejectable": true,
                "Subject": "IT Provisioning",
                "AssigneeLegacy": "it-support"
              }
            }
          ]
        },
        {
          "type": "UserTask",
          "Id": 5,
          "X": 600,
          "Y": 300,
          "Text": "HR Orientation",
          "comment": "Welcome kit and docs",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"UserTask\",\"data\":{\"label\":\"HR Orientation\",\"status\":\"idle\",\"assignee\":\"hr-team\",\"description\":\"Welcome kit and docs\",\"formSchema\":{\"fields\":[{\"id\":\"hr1\",\"label\":\"Contracts Signed\",\"key\":\"docsSigned\",\"type\":\"boolean\",\"required\":true},{\"id\":\"hr2\",\"label\":\"Kit Handed Over\",\"key\":\"kitGiven\",\"type\":\"boolean\",\"required\":true}]}},\"position\":{\"x\":600,\"y\":300}}"
            },
            {
              "Name": "PSS.Forms",
              "Data": {
                "FormFields": [
                  {
                    "Id": "docsSigned",
                    "Label": "Contracts Signed",
                    "Required": true,
                    "ValueType": "boolean",
                    "Extensions": {
                      "input": "checkbox"
                    }
                  },
                  {
                    "Id": "kitGiven",
                    "Label": "Kit Handed Over",
                    "Required": true,
                    "ValueType": "boolean",
                    "Extensions": {
                      "input": "checkbox"
                    }
                  }
                ]
              }
            },
            {
              "Name": "PSS.GenericUserTask",
              "Data": {
                "Assignments": [],
                "Mode": "continue",
                "Step": 1,
                "Rejectable": true,
                "Subject": "HR Orientation",
                "AssigneeLegacy": "hr-team"
              }
            }
          ]
        },
        {
          "type": "ParallelGateway",
          "Id": 6,
          "X": 800,
          "Y": 200,
          "Text": "Merge Streams",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ParallelGateway\",\"data\":{\"label\":\"Merge Streams\",\"status\":\"idle\",\"isMerging\":true},\"position\":{\"x\":800,\"y\":200}}"
            }
          ],
          "IsMerging": true
        },
        {
          "type": "ServiceTask",
          "Id": 7,
          "X": 950,
          "Y": 200,
          "Text": "Welcome Email",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ServiceTaskEmail\",\"data\":{\"label\":\"Welcome Email\",\"status\":\"idle\",\"to\":\"${generatedEmail}\",\"subject\":\"Welcome to Peak Systems!\",\"body\":\"Hello ${fullName},\\n\\nWelcome to the ${dept} team. Your IT setup is complete.\\n\\nLaptop ID: ${laptopId}\\n\\nBest,\\nHR\"},\"position\":{\"x\":950,\"y\":200}}"
            },
            {
              "Name": "PSS.EmailTask",
              "Data": {
                "Topic": "Query",
                "Receipients": [
                  {
                    "Kind": "TO",
                    "Email": "${generatedEmail}",
                    "Name": "${generatedEmail}"
                  }
                ],
                "Subject": "Welcome to Peak Systems!",
                "Content": "Hello ${fullName},\n\nWelcome to the ${dept} team. Your IT setup is complete.\n\nLaptop ID: ${laptopId}\n\nBest,\nHR",
                "Attachments": []
              }
            }
          ]
        },
        {
          "type": "BlankEndEvent",
          "Id": 8,
          "X": 1150,
          "Y": 200,
          "Text": "Onboarding Complete",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"BlankEndEvent\",\"data\":{\"label\":\"Onboarding Complete\",\"status\":\"idle\"},\"position\":{\"x\":1150,\"y\":200}}"
            }
          ]
        }
      ],
      "Connections": [
        {
          "From": 1,
          "To": 2,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 2,
          "To": 3,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 3,
          "To": 4,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 3,
          "To": 5,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 4,
          "To": 6,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 5,
          "To": 6,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 6,
          "To": 7,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 7,
          "To": 8,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        }
      ],
      "RecursiveConnections": []
    },
    {
      "Name": "Smart Order Fulfillment",
      "IsSubProcess": false,
      "Nodes": [
        {
          "type": "MessageStartEvent",
          "Id": 1,
          "X": 50,
          "Y": 250,
          "Text": "Order Received",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"MessageStartEvent\",\"data\":{\"label\":\"Order Received\",\"status\":\"idle\",\"messageName\":\"NewOrder\"},\"position\":{\"x\":50,\"y\":250}}"
            }
          ],
          "Message": "NewOrder"
        },
        {
          "type": "ServiceTask",
          "Id": 2,
          "X": 250,
          "Y": 250,
          "Text": "AI Fraud Check",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ServiceTaskLLM\",\"data\":{\"label\":\"AI Fraud Check\",\"status\":\"idle\",\"model\":\"gemini-3-flash-preview\",\"systemPrompt\":\"You are a fraud detection agent. Analyze the order JSON. Return JSON with \\\"riskLevel\\\": \\\"high\\\" or \\\"low\\\" and \\\"reason\\\".\",\"userPrompt\":\"Analyze this order: ${JSON.stringify(variables.order)}\",\"outputVariable\":\"fraudAnalysis\"},\"position\":{\"x\":250,\"y\":250}}"
            },
            {
              "Name": "PSS.AgentTask",
              "Data": {
                "Model": "gemini-3-flash-preview",
                "SystemPrompt": "You are a fraud detection agent. Analyze the order JSON. Return JSON with \"riskLevel\": \"high\" or \"low\" and \"reason\".",
                "UserPrompt": "Analyze this order: ${JSON.stringify(variables.order)}",
                "OutputVariable": "fraudAnalysis"
              }
            }
          ]
        },
        {
          "type": "XorGateway",
          "Id": 3,
          "X": 450,
          "Y": 250,
          "Text": "Risk Check",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"XorGateway\",\"data\":{\"label\":\"Risk Check\",\"status\":\"idle\",\"outputs\":[\"High Risk\",\"Low Risk\"],\"conditions\":[{\"path\":0,\"expression\":\"variables.fraudAnalysis?.riskLevel === 'high'\"},{\"path\":1,\"expression\":\"true\"}]},\"position\":{\"x\":450,\"y\":250}}"
            }
          ],
          "IsMerging": false,
          "DefaultPath": -1,
          "Expressions": {
            "cond_0": "variables.fraudAnalysis?.riskLevel === 'high'",
            "cond_1": "true"
          },
          "ExpressionMapping": {
            "4": "cond_0",
            "7": "cond_1"
          }
        },
        {
          "type": "UserTask",
          "Id": 4,
          "X": 550,
          "Y": 100,
          "Text": "Manual Review",
          "comment": "Review high risk order",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"UserTask\",\"data\":{\"label\":\"Manual Review\",\"status\":\"idle\",\"description\":\"Review high risk order\",\"formSchema\":{\"fields\":[{\"id\":\"rv1\",\"label\":\"Decision\",\"key\":\"reviewDecision\",\"type\":\"select\",\"options\":\"Approve,Reject\",\"required\":true},{\"id\":\"rv2\",\"label\":\"Notes\",\"key\":\"reviewNotes\",\"type\":\"textarea\",\"required\":false}]}},\"position\":{\"x\":550,\"y\":100}}"
            },
            {
              "Name": "PSS.Forms",
              "Data": {
                "FormFields": [
                  {
                    "Id": "reviewDecision",
                    "Label": "Decision",
                    "Required": true,
                    "ValueType": "enum",
                    "Extensions": {
                      "input": "select",
                      "options": "Approve,Reject"
                    }
                  },
                  {
                    "Id": "reviewNotes",
                    "Label": "Notes",
                    "Required": false,
                    "ValueType": "string",
                    "Extensions": {
                      "input": "textarea"
                    }
                  }
                ]
              }
            },
            {
              "Name": "PSS.GenericUserTask",
              "Data": {
                "Assignments": [],
                "Mode": "continue",
                "Step": 1,
                "Rejectable": true,
                "Subject": "Manual Review"
              }
            }
          ]
        },
        {
          "type": "XorGateway",
          "Id": 5,
          "X": 750,
          "Y": 100,
          "Text": "Decision",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"XorGateway\",\"data\":{\"label\":\"Decision\",\"status\":\"idle\",\"outputs\":[\"Rejected\",\"Approved\"],\"conditions\":[{\"path\":0,\"expression\":\"variables.reviewDecision === 'Reject'\"},{\"path\":1,\"expression\":\"true\"}]},\"position\":{\"x\":750,\"y\":100}}"
            }
          ],
          "IsMerging": false,
          "DefaultPath": -1,
          "Expressions": {
            "cond_0": "variables.reviewDecision === 'Reject'",
            "cond_1": "true"
          },
          "ExpressionMapping": {
            "6": "cond_0",
            "7": "cond_1"
          }
        },
        {
          "type": "TerminateEndEvent",
          "Id": 6,
          "X": 880,
          "Y": 40,
          "Text": "Order Rejected",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"TerminateEndEvent\",\"data\":{\"label\":\"Order Rejected\",\"status\":\"idle\"},\"position\":{\"x\":880,\"y\":40}}"
            }
          ]
        },
        {
          "type": "ServiceTask",
          "Id": 7,
          "X": 750,
          "Y": 250,
          "Text": "Charge Card",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ServiceTaskREST\",\"data\":{\"label\":\"Charge Card\",\"status\":\"idle\",\"method\":\"POST\",\"endpoint\":\"https://api.payment-provider.com/charge\",\"requestBody\":\"{\\\"amount\\\": \\\"${order.total}\\\", \\\"token\\\": \\\"${order.paymentToken}\\\"}\"},\"position\":{\"x\":750,\"y\":250}}"
            },
            {
              "Name": "PSS.RestTask",
              "Data": {
                "Topic": "Query",
                "EndPoint": "https://api.payment-provider.com/charge",
                "Method": 1,
                "Body": "{\"amount\": \"${order.total}\", \"token\": \"${order.paymentToken}\"}",
                "Extensions": null
              }
            }
          ]
        },
        {
          "type": "IntermediateCatchTimerEvent",
          "Id": 8,
          "X": 950,
          "Y": 250,
          "Text": "Wait Warehouse",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"IntermediateCatchTimerEvent\",\"data\":{\"label\":\"Wait Warehouse\",\"status\":\"idle\",\"timerDefinition\":\"PT5M\"},\"position\":{\"x\":950,\"y\":250}}"
            }
          ],
          "Timer": "PT5M"
        },
        {
          "type": "ServiceTask",
          "Id": 9,
          "X": 1100,
          "Y": 250,
          "Text": "Update Inventory",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ServiceTaskDB\",\"data\":{\"label\":\"Update Inventory\",\"status\":\"idle\"},\"position\":{\"x\":1100,\"y\":250}}"
            },
            {
              "Name": "PSS.DatabaseTask",
              "Data": {}
            }
          ]
        },
        {
          "type": "MessageEndEvent",
          "Id": 10,
          "X": 1300,
          "Y": 250,
          "Text": "Order Shipped",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"MessageEndEvent\",\"data\":{\"label\":\"Order Shipped\",\"status\":\"idle\"},\"position\":{\"x\":1300,\"y\":250}}"
            }
          ]
        }
      ],
      "Connections": [
        {
          "From": 1,
          "To": 2,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 2,
          "To": 3,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 3,
          "To": 4,
          "ExpressionName": "High Risk",
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 4,
          "To": 5,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 5,
          "To": 6,
          "ExpressionName": "Rejected",
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 5,
          "To": 7,
          "ExpressionName": "Approved",
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 3,
          "To": 7,
          "ExpressionName": "Low Risk",
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 7,
          "To": 8,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 8,
          "To": 9,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 9,
          "To": 10,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        }
      ],
      "RecursiveConnections": []
    },
    {
      "Name": "Incident Response (SLA)",
      "IsSubProcess": false,
      "Nodes": [
        {
          "type": "SignalStartEvent",
          "Id": 1,
          "X": 50,
          "Y": 200,
          "Text": "Server Alert",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"SignalStartEvent\",\"data\":{\"label\":\"Server Alert\",\"status\":\"idle\",\"signalName\":\"CPU_SPIKE\"},\"position\":{\"x\":50,\"y\":200}}"
            }
          ],
          "Signal": "CPU_SPIKE"
        },
        {
          "type": "ScriptTask",
          "Id": 2,
          "X": 200,
          "Y": 200,
          "Text": "Parse Logs",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ScriptTask\",\"data\":{\"label\":\"Parse Logs\",\"status\":\"idle\",\"script\":\"// Extract severity from alert payload\\nconst severity = variables.alert?.severity || 'LOW';\\n\\nreturn {\\n  isCritical: severity === 'CRITICAL',\\n  requiresManager: severity === 'HIGH' || severity === 'CRITICAL'\\n};\"},\"position\":{\"x\":200,\"y\":200}}"
            }
          ],
          "Script": 2
        },
        {
          "type": "InclusiveGateway",
          "Id": 3,
          "X": 400,
          "Y": 200,
          "Text": "Notify Channels",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"InclusiveGateway\",\"data\":{\"label\":\"Notify Channels\",\"status\":\"idle\",\"outputs\":[\"Email Team\",\"Slack Channel\"],\"conditions\":[{\"path\":0,\"expression\":\"true\"},{\"path\":1,\"expression\":\"variables.isCritical\"}]},\"position\":{\"x\":400,\"y\":200}}"
            }
          ],
          "IsMerging": false,
          "DefaultPath": -1,
          "Expressions": {
            "cond_0": "true",
            "cond_1": "variables.isCritical"
          },
          "ExpressionMapping": {
            "4": "cond_0",
            "5": "cond_1"
          }
        },
        {
          "type": "ServiceTask",
          "Id": 4,
          "X": 600,
          "Y": 100,
          "Text": "Email DevOps",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ServiceTaskEmail\",\"data\":{\"label\":\"Email DevOps\",\"status\":\"idle\",\"to\":\"devops@peak.com\",\"subject\":\"Incident Alert\"},\"position\":{\"x\":600,\"y\":100}}"
            },
            {
              "Name": "PSS.EmailTask",
              "Data": {
                "Topic": "Query",
                "Receipients": [
                  {
                    "Kind": "TO",
                    "Email": "devops@peak.com",
                    "Name": "devops@peak.com"
                  }
                ],
                "Subject": "Incident Alert",
                "Attachments": []
              }
            }
          ]
        },
        {
          "type": "ServiceTask",
          "Id": 5,
          "X": 600,
          "Y": 300,
          "Text": "Post to Slack",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ServiceTaskREST\",\"data\":{\"label\":\"Post to Slack\",\"status\":\"idle\",\"endpoint\":\"https://slack.com/api/chat.postMessage\",\"method\":\"POST\"},\"position\":{\"x\":600,\"y\":300}}"
            },
            {
              "Name": "PSS.RestTask",
              "Data": {
                "Topic": "Query",
                "EndPoint": "https://slack.com/api/chat.postMessage",
                "Method": 1,
                "Extensions": null
              }
            }
          ]
        },
        {
          "type": "InclusiveGateway",
          "Id": 6,
          "X": 800,
          "Y": 200,
          "Text": "Merge",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"InclusiveGateway\",\"data\":{\"label\":\"Merge\",\"status\":\"idle\",\"isMerging\":true},\"position\":{\"x\":800,\"y\":200}}"
            }
          ],
          "IsMerging": true,
          "DefaultPath": -1
        },
        {
          "type": "UserTask",
          "Id": 7,
          "X": 950,
          "Y": 200,
          "Text": "Resolve Incident",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"UserTask\",\"data\":{\"label\":\"Resolve Incident\",\"status\":\"idle\",\"assignee\":\"on-call-eng\",\"priority\":\"1\"},\"position\":{\"x\":950,\"y\":200}}"
            },
            {
              "Name": "PSS.GenericUserTask",
              "Data": {
                "Assignments": [],
                "Mode": "continue",
                "Step": 1,
                "Rejectable": true,
                "Subject": "Resolve Incident",
                "AssigneeLegacy": "on-call-eng"
              }
            }
          ],
          "BoundaryEvents": [
            8
          ]
        },
        {
          "type": "TimerBoundaryEvent",
          "Id": 8,
          "X": 1070,
          "Y": 250,
          "Text": "1h SLA",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"TimerBoundaryEvent\",\"data\":{\"label\":\"1h SLA\",\"status\":\"idle\",\"cancelActivity\":true,\"timerDefinition\":\"PT1H\"},\"position\":{\"x\":120,\"y\":50}}"
            }
          ],
          "Timer": "PT1H",
          "Activity": 7
        },
        {
          "type": "SignalEndEvent",
          "Id": 9,
          "X": 1200,
          "Y": 200,
          "Text": "Resolved",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"SignalEndEvent\",\"data\":{\"label\":\"Resolved\",\"status\":\"idle\"},\"position\":{\"x\":1200,\"y\":200}}"
            }
          ]
        },
        {
          "type": "ServiceTask",
          "Id": 10,
          "X": 1020,
          "Y": 380,
          "Text": "Escalate to CTO",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"ServiceTaskEmail\",\"data\":{\"label\":\"Escalate to CTO\",\"status\":\"idle\",\"to\":\"cto@peak.com\",\"subject\":\"SLA BREACHED\",\"priority\":\"high\"},\"position\":{\"x\":1020,\"y\":380}}"
            },
            {
              "Name": "PSS.EmailTask",
              "Data": {
                "Topic": "Query",
                "Receipients": [
                  {
                    "Kind": "TO",
                    "Email": "cto@peak.com",
                    "Name": "cto@peak.com"
                  }
                ],
                "Subject": "SLA BREACHED",
                "Attachments": []
              }
            }
          ]
        },
        {
          "type": "TerminateEndEvent",
          "Id": 11,
          "X": 1200,
          "Y": 380,
          "Text": "SLA Failed",
          "Extensions": [
            {
              "Key": "__EditorData",
              "Value": "{\"type\":\"TerminateEndEvent\",\"data\":{\"label\":\"SLA Failed\",\"status\":\"idle\"},\"position\":{\"x\":1200,\"y\":380}}"
            }
          ]
        }
      ],
      "Connections": [
        {
          "From": 1,
          "To": 2,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 2,
          "To": 3,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 3,
          "To": 4,
          "ExpressionName": "Email Team",
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 3,
          "To": 5,
          "ExpressionName": "Slack Channel",
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 4,
          "To": 6,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 5,
          "To": 6,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 6,
          "To": 7,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 7,
          "To": 9,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 7,
          "To": 10,
          "ExpressionName": "SLA Breach",
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        },
        {
          "From": 10,
          "To": 11,
          "StartPoint": 1,
          "EndPoint": 3,
          "IsDefault": false
        }
      ],
      "RecursiveConnections": []
    }
  ]
};

export const defaultProcesses = parseWorkflowProject(projectData);
